const accordianHeading = document.querySelectorAll(
  ".accordian .accordian-button",
)
accordianHeading.forEach((anchor) => {
  anchor.addEventListener("click", function (event) {
    event.preventDefault()
    this.parentElement.parentElement.classList.toggle("active")
  })
})

function equalizeHeadingMinHeight() {
  const headings = document.querySelectorAll(".accordian-heading")
  let maxHeight = 0

  // Reset before measuring
  headings.forEach((el) => {
    el.style.minHeight = ""
  })

  // Measure actual rendered height
  headings.forEach((el) => {
    const height = el.getBoundingClientRect().height
    if (height > maxHeight) {
      maxHeight = height
    }
  })

  // Apply rounded value
  headings.forEach((el) => {
    el.style.minHeight = `${Math.ceil(maxHeight)}px`
  })
}

window.addEventListener("load", equalizeHeadingMinHeight)
window.addEventListener("resize", equalizeHeadingMinHeight)
